package ru.malygin.myConst

import kotlinx.datetime.DayOfWeek
import kotlinx.serialization.Serializable

enum class WeekDay(
    val index: Int,
    val shortName:String,
    val fullName: String,
)
{
    MONDAY(
        index = 0,
        shortName = "ПН",
        fullName = "Понедельник",
    ),
    TUESDAY(
        index = 1,
        shortName = "ВТ",
        fullName = "Вторник",
    ),
    WEDNESDAY(
        index = 2,
        shortName = "СР",
        fullName = "Среда",
    ),
    THURSDAY(
        index = 3,
        shortName = "ЧТ",
        fullName = "Четверг",
    ),
    FRIDAY(
        index = 4,
        shortName = "ПТ",
        fullName = "Пятница",
    ),
    SATURDAY(
        index = 5,
        shortName = "СБ",
        fullName = "Суббота",
    ),
}

fun String.toWeekDay(): WeekDay {
    return when(this){
        "MONDAY"-> WeekDay.MONDAY
        "TUESDAY"-> WeekDay.TUESDAY
        "WEDNESDAY"-> WeekDay.WEDNESDAY
        "THURSDAY"-> WeekDay.THURSDAY
        "FRIDAY"-> WeekDay.FRIDAY
        "SATURDAY"-> WeekDay.SATURDAY
        "Понедельник"-> WeekDay.MONDAY
        "Вторник"-> WeekDay.TUESDAY
        "Среда"-> WeekDay.WEDNESDAY
        "Четверг"-> WeekDay.THURSDAY
        "Пятница"-> WeekDay.FRIDAY
        "Суббота"-> WeekDay.SATURDAY
        else -> WeekDay.MONDAY
    }
}
fun DayOfWeek.toWeekDay(): WeekDay {
    return when(this){
        DayOfWeek.MONDAY-> WeekDay.MONDAY
        DayOfWeek.TUESDAY-> WeekDay.TUESDAY
        DayOfWeek.WEDNESDAY-> WeekDay.WEDNESDAY
        DayOfWeek.THURSDAY-> WeekDay.THURSDAY
        DayOfWeek.FRIDAY-> WeekDay.FRIDAY
        DayOfWeek.SATURDAY-> WeekDay.SATURDAY
        else -> WeekDay.MONDAY
    }
}

enum class CellType {
    STANDARD,
    EXPANSION,
}

fun String.toCellType(): CellType {
    return when(this){
        "STANDARD"-> CellType.STANDARD
        "EXPANSION"-> CellType.EXPANSION
        else -> CellType.STANDARD
    }
}

@Serializable
enum class SelectedCategory(
    val trn: String,
) {
    NONE(
        trn = "нет данных",
    ),
    GROUPS(
        trn = "Группы"
    ),
    TEACHERS(
        trn = "Преподаватели"
    ),
    TUTORS(
        trn = "Кураторы"
    ),
}

fun String?.toSelectedCategory(): SelectedCategory {
    return when(this){
        "GROUPS"-> SelectedCategory.GROUPS
        "TEACHERS"-> SelectedCategory.TEACHERS
        "TUTORS" -> SelectedCategory.TUTORS
        else -> SelectedCategory.NONE
    }
}


